import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    message: '',
    show: false

  },
  mutations: {
    setMessage(s, message){
      Vue.set(s, 'message', message)
    },
    setShow(s, show) {
      Vue.set(s, 'show', show)
    }

  },
  actions: {

  },
  getters: {
  }
})
